import { Link } from 'react-router-dom';
import { blogPosts } from '../../../mocks/blog';
import { useTranslation } from 'react-i18next';

export const BlogPreview = () => {
  const { t } = useTranslation();
  const recent = blogPosts.slice(0, 3);

  return (
    <section className="py-20 bg-[#0a0018]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between mb-12 gap-6">
          <div>
            <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-3">{t('home_blog_badge')}</p>
            <h2 className="text-3xl lg:text-4xl font-bold text-white">
              {t('home_blog_title')}{' '}
              <span className="text-transparent bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text">{t('home_blog_title2')}</span>
            </h2>
          </div>
          <Link
            to="/blog"
            className="flex items-center gap-2 px-6 py-3 border border-violet-500/25 text-violet-300 rounded-full text-sm whitespace-nowrap hover:bg-violet-500/10 transition-colors cursor-pointer"
          >
            {t('cta_allArticles')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {recent.map(post => (
            <Link
              key={post.id}
              to={`/blog/${post.id}`}
              className="group bg-[#110020]/70 border border-violet-500/12 rounded-2xl overflow-hidden hover:border-violet-500/35 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050010] via-transparent to-transparent" />
                <span className="absolute top-3 left-3 px-3 py-1 bg-black/40 backdrop-blur-sm border border-violet-500/20 text-violet-300 text-xs rounded-full">
                  {post.category}
                </span>
              </div>

              <div className="p-5">
                <h4 className="text-white font-semibold text-sm leading-snug mb-3 group-hover:text-violet-400 transition-colors">
                  {post.title}
                </h4>
                <p className="text-white/40 text-xs leading-relaxed mb-4 line-clamp-2">{post.excerpt}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <img src={post.authorAvatar} alt={post.author} className="w-6 h-6 rounded-full object-cover" />
                    <span className="text-white/35 text-xs">{post.author}</span>
                  </div>
                  <div className="flex items-center gap-3 text-white/25 text-xs">
                    <span>{post.readTime}</span>
                    <span>{post.date}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
